import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule, forwardRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { NgSelectModule } from '@ng-select/ng-select';
import { EditorModule } from '@tinymce/tinymce-angular';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxLoadingModule } from 'ngx-loading';
import { MonacoEditorModule } from 'ngx-monaco-editor';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ToastrModule } from 'ngx-toastr';
import { NgxViewerModule } from 'ngx-viewer';
import 'tinymce/icons/default';
import { AlertComponent } from '../dialog/alert/alert.component';
import { ConfirmComponent } from '../dialog/confirm/confirm.component';
import { DialogModule } from '../dialog/dialog.module';
import { MultipleButtonComponent } from '../dialog/multiple-button/multiple-button.component';
import { MapboxModule } from '../mapbox/mapbox.module';
import { MarkdownComponent } from '../question/markdown/markdown.component';
import { SearchFilterComponent } from '../search.filter/search-filter.component';
import { VersionCloneModalComponent } from '../version/version-clone-modal/version-clone-modal.component';
import { DatepickerInputComponent } from './_components/datepicker-input/datepicker-input.component';
import { ImgAjaxComponent } from './_components/img-ajax/img-ajax.component';
import { ListViewComponent } from './_components/list-view/list-view.component';
import { SendEmailModalComponent } from './_components/send-email-modal/send-email-modal.component';
import { TabsComponent } from './_components/tabs/tabs.component';
import { ViewEmailModalComponent } from './_components/view-email-modal/view-email-modal.component';
import { ExtractTextPipe } from './extract-text.pipe';
import { ForScrollDirective } from './for-scroll.directive';
import { LoaderService } from './loader.service';
import { MergeAnswersService } from './merge.answers.service';
import { InspectionModule } from '../inspection/inspection.module';
import { InspectionFilterCardsComponent } from './_components/inspection-filter-cards/inspection-filter-cards.component';
import { AdminAssignmentInspectionComponent } from './_components/admin-assignment/admin-assignmentcomponent';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    TypeaheadModule.forRoot(),
    PaginationModule.forRoot(),
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ToastrModule.forRoot({ positionClass: 'toast-top-right' }),
    DragDropModule,
    CollapseModule.forRoot(),
    DialogModule,
    LeafletModule.forRoot(),
    NgSelectModule,
    NgxViewerModule,
    MonacoEditorModule.forRoot(),
    MapboxModule,
    NgxLoadingModule,
    PerfectScrollbarModule,
    EditorModule,
    RouterModule,
    NgxDaterangepickerMd.forRoot(),
  ],
  declarations: [
    ImgAjaxComponent,
    MarkdownComponent,
    SearchFilterComponent,
    VersionCloneModalComponent,
    SendEmailModalComponent,
    ForScrollDirective,
    ViewEmailModalComponent,
    ListViewComponent,
    TabsComponent,
    DatepickerInputComponent,
    ExtractTextPipe,
    InspectionFilterCardsComponent,
    AdminAssignmentInspectionComponent,
  ],
  exports: [
    AlertComponent,
    ConfirmComponent,
    MultipleButtonComponent,
    CommonModule,
    TypeaheadModule,
    PaginationModule,
    BsDropdownModule,
    CollapseModule,
    ModalModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule,
    BsDatepickerModule,
    DragDropModule,
    ImgAjaxComponent,
    MarkdownComponent,
    LeafletModule,
    NgSelectModule,
    NgxViewerModule,
    MonacoEditorModule,
    MapboxModule,
    SearchFilterComponent,
    NgxLoadingModule,
    VersionCloneModalComponent,
    SendEmailModalComponent,
    ForScrollDirective,
    ListViewComponent,
    TabsComponent,
    DatepickerInputComponent,
    ExtractTextPipe,
    InspectionFilterCardsComponent,
    AdminAssignmentInspectionComponent,
  ],
  providers: [LoaderService, MergeAnswersService],
})
export class SharedModule {}
